"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/checkbox/examples/default.ts';
var CheckboxExample = /** @class */ (function () {
    function CheckboxExample() {
        this.disabled = false;
        this.label = true;
        this.readonly = false;
    }
    CheckboxExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Checkbox, {
                defaultChecked: true,
                disabled: this.disabled,
                label: this.label && 'Checkbox label',
                intent: this.intent,
                readonly: this.readonly,
                size: this.size
            })
        ]);
    };
    CheckboxExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.disabled,
                label: 'Disabled',
                onchange: function () { return _this.disabled = !_this.disabled; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.label,
                label: 'Label',
                onchange: function () { return _this.label = !_this.label; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.readonly,
                label: 'Readonly',
                onchange: function () { return _this.readonly = !_this.readonly; }
            })
        ];
    };
    return CheckboxExample;
}());
exports.CheckboxExample = CheckboxExample;
